import { isNumber } from "lodash";
import { forwardRef } from "react";

import type { Icon, IconProps } from "@tabler/icons-react";

export const IconDrag = forwardRef<Icon, IconProps>(
  ({ size = 24, stroke = "none", ...props }, ref) => {
    const currentStroke = isNumber(stroke) ? `${stroke}px` : stroke;

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="currentColor"
        stroke={currentStroke}
        {...props}
        ref={ref as any}
      >
        <path fillRule="evenodd" clipRule="evenodd" d="M5 11H19V9H5V11ZM5 15H19V13H5V15Z" />
        <path fillRule="evenodd" clipRule="evenodd" d="M5 11H19V9H5V11ZM5 15H19V13H5V15Z" />
      </svg>
    );
  }
);
